import { useState } from 'react';
import { RiArrowLeftLine, RiArrowRightLine, RiFullscreenLine } from 'react-icons/ri';

import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/shared/components/ui/dialog';

import { EquipmentImage } from './equipment-image';

export const ProductGallery = ({ images, name }: { images: string[]; name: string }) => {
  const [active, setActive] = useState(0);
  const previous = () => setActive((index) => (index + images.length - 1) % images.length);
  const next = () => setActive((index) => (index + 1) % images.length);
  return (
    <div className="product-gallery">
      <Dialog>
        <DialogTrigger asChild>
          <button className="product-gallery__main" aria-label="Увеличить фотографию оборудования" type="button">
            <EquipmentImage src={images[active]} alt={name} fill priority sizes="(max-width:700px) 100vw, 60vw" />
            <span>
              <RiFullscreenLine />
            </span>
          </button>
        </DialogTrigger>
        <DialogContent className="product-zoom">
          <DialogTitle className="sr-only">{name}</DialogTitle>
          <EquipmentImage src={images[active]} alt={name} fill sizes="90vw" />
          {images.length > 1 && (
            <div className="zoom-navigation">
              <button onClick={previous} aria-label="Предыдущее фото">
                <RiArrowLeftLine />
              </button>
              <span>
                {active + 1} / {images.length}
              </span>
              <button onClick={next} aria-label="Следующее фото">
                <RiArrowRightLine />
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
      {images.length > 1 && (
        <div className="product-gallery__thumbs">
          {images.map((image, index) => (
            <button
              key={image}
              className={index === active ? 'is-active' : ''}
              type="button"
              onClick={() => setActive(index)}
              aria-label={`Фото ${index + 1}`}
              aria-pressed={active === index}
            >
              <EquipmentImage src={image} alt={`${name}, ракурс ${index + 1}`} fill sizes="100px" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
